import React from "react";
import Reflux from "reflux";
import GrComponentFactory from "../gr_component_factory";
import UserRatingsStore from "../../react_stores/user_ratings_store";
import ProgressBar from "../progress_bar";

export default GrComponentFactory.createClass({
  displayName: "ImproveRecommendations",
  mixins: [Reflux.connectFilter(UserRatingsStore, "ratingsCount", (storeData) => storeData.ratingsCount),
  ],
  propTypes: {
    maxRecsCount: React.PropTypes.number,
    rateBooksUrl: React.PropTypes.string,
  },

  renderPercent() {
    return `${Math.round((this.state.ratingsCount / this.props.maxRecsCount) * 100)}%`;
  },

  renderCopy() {
    if (this.state.ratingsCount < this.props.maxRecsCount) {
      return <div className="u-marginBottomXSmall">
               Rating at least {this.props.maxRecsCount} books improves your recommendations.
               You have rated {this.state.ratingsCount}.
             </div>;
    } else {
      return <div className="u-marginBottomXSmall">
               You have rated at least {this.props.maxRecsCount} books!
               Your recommendations are being recalculated.
             </div>;
    }
  },

  render() {
    return <section className="gr-homePageRailContainer
                               u-paddingBottomMedium">
             <h3>Improve Recommendations</h3>
             {this.renderCopy()}
             <ProgressBar value={this.state.ratingsCount}
                          max={this.props.maxRecsCount}
                          width="80%" />
             <div className="gr-metaText u-marginTopTiny">
               {`${this.state.ratingsCount}/${this.props.maxRecsCount} (${this.renderPercent()})`}
             </div>
             <a href={this.props.rateBooksUrl} className="u-displayBlock u-marginTopXSmall">
               Rate more books
             </a>
           </section>;
  },
});
